module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main